import React from 'react';
import {
  Link, Row, Col, Typography, LeftCircleOutlined, useTranslation,
} from '@lib/index';
import { ENV } from '@config/envConfig';
import { isAzureLoginEnabled } from '@config/ssoConfig';
import IntercomWatcher from '@app/intercomWatcher';
import { EmbeddedLoginProps } from '../types';
import Auth0LoginControls from './Auth0LoginControls';
import AzureLoginControls from './AzureLoginControls';

const ExternalLogin = ({ embedded = false }: EmbeddedLoginProps) => {
  const { Title } = Typography;
  const { t } = useTranslation();
  const auth0Enabled = String(ENV.VITE_AUTH0_ENABLED ?? import.meta.env.VITE_AUTH0_ENABLED) === 'true';
  const azureLoginEnabled = isAzureLoginEnabled();

  const loginCardContent = (
    <>
      <Title className="font-bold text-center text-[#252B42] mb-1 mt-0 text-lg">
        {t('login.title')}
      </Title>
      <Row>
        {auth0Enabled && <Auth0LoginControls />}
        {azureLoginEnabled && <AzureLoginControls />}
      </Row>
    </>
  );

  if (embedded) {
    return (
      <div className="landing-fonts">
        <IntercomWatcher />
        <div className="p-5 w-full bg-white rounded-2xl shadow-2xl overflow-hidden max-w-[340px] m-auto" data-cy="login-form">
          {loginCardContent}
        </div>
      </div>
    );
  }

  const loginCard = (
    <div className="p-6 sm:p-12 mt-4 h-full w-full bg-white">
      {loginCardContent}
    </div>
  );

  return (
    <div className="bg-login-bg bg-no-repeat bg-cover h-screen overflow-auto bg-center py-24 2xl:p-24 shadow-inner" data-cy="login-form">
      <IntercomWatcher />
      <Row align="middle" justify="center" className="mt-0">
        <Col xs={22} sm={18} md={12} lg={12} xl={6} className="mt-0">
          <Link to="/" className="text-white text-2xl">
            <LeftCircleOutlined className="text-white text-2xl pr-8" />
            {t('login.backToSite')}
          </Link>
          {loginCard}
        </Col>
      </Row>
    </div>
  );
};

ExternalLogin.defaultProps = {
  embedded: false,
};

export default ExternalLogin;
